import TEMPLATE_URL from "emun.order/order-multi-add.htm";
import controller from "emun.order/order-multi-add.controller";
import open from "webmodals/open";

export default ({
  size = "xl",
  backdrop = "static",
  placement = "center",
  templateUrl = TEMPLATE_URL,
  mode = "multi-add",
  imageSize = "xxs",
  criteria = {},
  updateItems = false,
  httpMethod = "GET",
  title = `Add Products...`,
  subTitle,
}) =>
  open({
    size,
    backdrop,
    templateUrl,
    placement,
    controller,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      title: () => title,
      subTitle: () => subTitle,
      mode: () => mode,
      imageSize: () => imageSize,
      httpMethod: () => httpMethod,
      criteria: () => criteria,
      updateItems: () => updateItems,
    },
  }).result;
